<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h4 style="font-weight: bold;color:#3d464c;">
          {{ $t($route.name) }}
          <span v-if="$route.params.id != undefined">№{{ $route.params.id }}</span>
          {{ Datetime(datas.created_at)}}
        </h4>
      </div>
      <div class="col-md-2" style="display: flex;">
        <label for="">Курс</label>
        <input :disabled="confirmed" type="text" v-model="datas.dollar_rate" class="kurs">
      </div>
      <div class="col-md-2">
        <span style="display: flex;" v-if="skladid==datas.transfer_sklad_id">
          <label for="" style="color: blue;margin: 0 5px;">{{$t('Тасдиқлаш')}}</label>
          <input class="form-control-sm" :disabled="changedisabledconfirm" v-model="datas.confirm" type="checkbox" />
        </span>
      </div>
      <div class="col-md-2 end">
        <button type="button" v-if="$route.params.id!=undefined && settedrule.change==true" @click="Change()"
          class="btn btn-primary change">{{$t('Ўзгартириш')}}</button>
        <router-link class="btn btn-danger" :to="{ path: '/transfer/index' }">
          <button type="button" class="closebutton">
            <b-icon icon="x-lg"></b-icon>
          </button>
        </router-link>
      </div>
    </div>
    <div class="rowform">
      <div class="col-md-1 topheader">
        <span>
          <label for="">Факт №</label>
          <input type="number" :disabled="confirmed" class="input100" v-model="datas.number">
        </span>
      </div>
      <!-- <div class="col-md-2 topheader">
        <span>
          <label for="">{{$t('Вақт')}}</label>
          <input type="datetime-local" class="input100" v-model="datas.created_at">
        </span>
      </div> -->
      <div class="col-md-3 topheader">
        <span>
          <label>Склад1</label>
          <v-select :disabled="true" :clearable="false" class="form-control-sm required md-input" :options="skladlist"
            v-model="datas.sklad_id" :reduce="name => name.id" label="name" @input="Doklist()">
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-3 topheader">
        <span>
          <label>Склад2</label>
          <v-select :disabled="confirmed" :clearable="false" class="form-control-sm required md-input"
            :options="skladlist2" v-model="datas.transfer_sklad_id" :reduce="name => name.id" label="name"
            @input="Sklad2change()">
            <template #search="{ attributes, events }">
              <input class="vs__search" ref="focused" v-bind="attributes" v-on="events" aria-activedescendant="null" />
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>{{ $t("Тўлов тури") }}</label>
          <v-select :disabled="confirmed" :clearable="false" class="form-control-sm required md-input"
            :options="paytypelist" v-model="datas.pay_type_id" :reduce="name => name.id" label="name">
            <template #list-footer>
              <li style="text-align: center;font-weight:bold;">
                f4 {{ $t("умумий рўйхат") }}
              </li>
            </template>
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" />
              <button type="button" class="modallist" v-b-modal.modal-paytypelist>
                <b-icon icon="three-dots"></b-icon>
              </button>
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-3 topheader">
        <span>
          <label>Комментарий</label>
          <input :disabled="confirmed" v-model="datas.comment" class="needt" type="text">
        </span>
      </div>
    </div>
    <div class="tableparentdiv">
      <table class="create_table">
        <thead>
          <tr>
            <th class="column0">№</th>
            <th class="column2">Штрих код</th>
            <th class="column3">Товар</th>
            <th class="column1">{{ $t("Кол.") }}</th>
            <th class="column1">{{ $t("Қолдиқ") }}</th>
            <th class="column2">{{ $t("Нарх") }} ({{ $t("Кирим") }})</th>
            <th class="column2 kol">Сумма ({{ $t("Кирим") }})</th>
            <th class="column2">{{ $t("Чакана") }} (%)</th>
            <th class="column1">{{ $t("Чакана") }}({{ $t("Нарх") }})</th>
            <th class="column1">{{ $t("Чакана") }}({{ $t("Нарх") }}$)</th>
            <th class="column1">{{ $t("Улгуржи") }} (%)</th>
            <th class="column1">{{ $t("Улгуржи") }}<br>({{ $t("Нарх") }})</th>
            <th class="column1">{{ $t("Улгуржи") }}<br>({{ $t("Нарх") }}$)</th>
            <th class="column0"></th>
          </tr>
        </thead>
        <tbody style="overflow: hidden;">
          <div style="height: 62vh!important;overflow-y: scroll;">
            <tr :style="{ height: `${index / 1000 + 10}px` }" v-for="(item, index) in datas.transfer_table"
              :key="index">
              <td class="column0">{{ index + 1 }}</td>
              <td class="column2">
                <input :disabled="confirmed" class="table-input" type="text" v-model="item.shtrix_kod"
                  @change="Shtrix(index)" />
              </td>
              <td class="column3">
                <v-select :disabled="confirmed" v-if="productlist != null" :filter-by="$store.state.myFilter"
                  :clearable="false" class="form-control-sm required" @search="query => (search = query)"
                  :options="paginated" menu-props="auto" v-model="item.product_id" :reduce="extra_name => extra_name.id"
                  label="extra_name" @input="Productchange(index)">
                  <template #list-footer>
                    <li style="text-align: center;font-weight:bold;">
                      f4 {{ $t("умумий рўйхат") }}
                    </li>
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes"></span>
                    <button v-if="confirmed==false" type="button" class="modallist" @click="Selectproduct(index)">
                      <b-icon icon="three-dots"></b-icon>
                    </button>
                  </template>
                  <template #selected-option-container="{ option}">
                    <div class="vs__selected">
                      <span v-if="typeof option.extra_name === 'number'">{{
                        Label(option.extra_name)
                        }}</span>
                      <span v-else-if="option.id==0"></span>
                      <span v-else>{{ option.extra_name }}</span>
                    </div>
                  </template>
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                      <em><b>{{ search }}</b></em>
                      {{ $t("бўйича маьлумот йўқ") }}
                    </template>
                    <em style="opacity: 0.5" v-else>{{
                      $t("Маьлумот йўқ")
                      }}</em>
                  </template>
                  <template #search="{ search, searching }">
                    <template v-if="searching">
                      <em><b>{{ search }}</b></em>
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                    </template>
                  </template>
                </v-select>
              </td>
              <td class="column1">
                <vue-numeric :disabled="confirmed" separator="space" v-model="item.count" class="table-input"
                  @change="Changecount(index)" v-bind:precision="3">
                </vue-numeric>
              </td>
              <td class="column1">{{ item.current_balance | numFormat }}</td>
              <td class="column2">
                <vue-numeric :disabled="confirmed" separator="space" v-model="item.debit_price" class="table-input"
                  @change="Changeprice(index)" v-bind:precision="2">
                </vue-numeric>
              </td>
              <td class="column2 kol">{{ item.debit_summa | numFormat }}</td>
              <td class="column2">
                <input type="number" :disabled="confirmed" separator="space" style="text-align: center;"
                  v-bind:precision="1" v-model="item.chakana_percent" class="table-input"
                  @input="Changepercentchakana(index)">
              </td>
              <td class="column1">
                <vue-numeric separator="space" :disabled="confirmed" v-model="item.chakana_price" class="table-input"
                  @input="Changepricechakana(index)" v-bind:precision="0"></vue-numeric>
              </td>
              <td class="column1">
                <vue-numeric :disabled="confirmed" separator="space" v-model="item.chakana_dollar_price"
                  class="table-input needt" @change="Changepricechakanadollar(index)"
                  v-bind:precision="2"></vue-numeric>
              </td>
              <td class="column1">
                <input type="number" :disabled="confirmed" separator="space" style="text-align: center;"
                  v-bind:precision="1" v-model="item.optom_percent" class="table-input"
                  @input="Changepercentoptom(index)">
              </td>
              <td class="column1">
                <vue-numeric :disabled="confirmed" separator="space" v-model="item.optom_price"
                  class="table-input needt" @change="Changepriceoptom(index)"
                  v-on:keypress.native="Changeoptomprice(index)" v-bind:precision="2"></vue-numeric>
              </td>
              <td class="column1">
                <vue-numeric :disabled="confirmed" separator="space" v-model="item.optom_dollar_price"
                  class="table-input needt" @change="Changepriceoptom(index)"
                  v-on:keypress.native="Changepriceoptomdollar(index)" v-bind:precision="2"></vue-numeric>
              </td>
              <td class="column0">
                <a v-if="confirmed==false" href="javascript:void(0)" class="circul trash" @click="Trashitem(index)">
                  <b-icon icon="trash"></b-icon>
                </a>
              </td>
            </tr>
          </div>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-1 topminus">
        <span>{{$t('Сони')}}</span>
        <h4>{{datas.count_all|numFormat}}</h4>
      </div>
      <div class="col-md-2 end topminus">
        <span>Сумма</span>
        <h4>{{datas.summa|numFormat}}</h4>
      </div>
      <div class="col-md-5 end formbottom">
        <button v-if="confirmed==false" class="addrow mybtn btn" type="button" @click="Addtable()">
          <b-icon icon="plus-lg"></b-icon><sup>F1</sup>
        </button>
        <button :disabled="sending" class="btn mybtn" id="chek" type="button" @click="Savedokument('barcode')">
          <b-icon icon="upc-scan"></b-icon><sup></sup>
        </button>
        <button v-if="changedisabled==false" class="mybtn btn" type="button" @click="Savedokument('print')">
          <b-icon icon="printer"></b-icon>
        </button>
        <button v-if="confirmed==false" class="mybtn btn" type="button" v-b-modal.modal-doklist>
          {{ $t("Док юклаш") }}
        </button>
        <b-spinner smal v-if="sending"></b-spinner>
        <button v-if="changedisabled==false" class="mybtn btn saved" type="button" :disabled="sending"
          @click="Savedokument()">
          {{ $t("Сақлаш ва беркитиш") }}<sup>crl+enter</sup>
        </button>
      </div>
    </div>

    <b-modal id="modal-shtrix" title="Товар" hide-footer size="xl" @shown="Shoved" @hidden="Hide()">
      <div class="row">
        <input type="text" class="form-control searchtable" v-bind:placeholder="$t('Қидирув')" v-model="filter"
          ref="inputText2" />
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>№</th>
              <th>{{ $t("Номи") }}</th>
              <th>{{ $t("Қолдиқ") }}</th>
              <th>{{ $t("Чакана") }} {{ $t("Нарх") }}</th>
              <th>{{ $t("Улгуржи") }} {{ $t("Нарх") }}</th>
              <th>Штрих</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in filteredRows" :key="index">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>
                <button type="button" class="atable" @click="
                  datas.transfer_table[settedindex].product_id =
                    item.product_id;
                  Productchange(settedindex);
                  $bvModal.hide('modal-shtrix');
                ">
                  {{ item.extra_name }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                  datas.transfer_table[settedindex].product_id =
                    item.product_id;
                  Productchange(settedindex);
                  $bvModal.hide('modal-shtrix');
                ">
                  {{ item.balance }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                  datas.transfer_table[settedindex].product_id =
                    item.product_id;
                  Productchange(settedindex);
                  $bvModal.hide('modal-shtrix');
                " v-if="item.price_register[0]">
                  {{ item.price_register[0].chakana_price }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                  datas.transfer_table[settedindex].product_id =
                    item.product_id;
                  Productchange(settedindex);
                  $bvModal.hide('modal-shtrix');
                " v-if="item.price_register[0]">
                  {{ item.price_register[0].optom_price }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                  datas.transfer_table[settedindex].product_id =
                    item.product_id;
                  Productchange(settedindex);
                  $bvModal.hide('modal-shtrix');
                " v-if="item.shtrix_table[0]">
                  {{ item.shtrix_table[0].shtrix_kod }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <b-modal id="modal-doklist" title="Приход" hide-footer size="xl" @shown="Shoved" @hidden="Hide()">
      <div class="row">
        <input type="text" class="form-control searchtable" v-bind:placeholder="$t('Қидирув')" v-model="filter1"
          ref="inputText2" />
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>№</th>
              <th>Ид</th>
              <th>{{ $t("Вақт") }}</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in filtereddok" :key="index">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>
                <button type="button" :disabled="sending" class="atable" @click="SetDok(item.id)">
                  {{ item.id }}
                </button>
              </td>
              <td>
                <button type="button" :disabled="sending" class="atable" @click="SetDok(item.id)">
                  {{
                  new Date(item.created_at * 1000).toISOString().substr(0, 19)
                  }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <b-modal id="modal-tovarlistnew" hide-footer size="lg" @shown="Shoved" @hidden="Hide()"
      style="float: right!important;">
      <md-card>
        <md-card-content>
          <input type="text" ref="inputText2" class="form-control searchtable" v-bind:placeholder="$t('Қидирув')"
            v-model="filtermodal" @input="Productlistfolder(datas.sklad_id,parent)" data-layout="normal" />
          <table class="table table-bordered left">
            <thead style="width: calc(100% - 10px)!important;">
              <tr>
                <th class="column1">№</th>
                <th>{{ $t("Номи") }}</th>
                <th class="column2">{{ $t("Қолдиқ") }}</th>
                <th class="column3">{{$t("Нарх")}}</th>
              </tr>
            </thead>
            <tbody style="overflow: hidden;height: 80vh!important;">
              <VueAutoVirtualScrollList :totalHeight="600" :defaultHeight="25" class="virtual"
                style="width: 100%;height: 80vh!important;">
                <tr>
                  <span class="cursor" @click="Productlistfolder(datas.sklad_id,parent)">
                    <td class="column1">
                      <b-icon icon="arrow-left"></b-icon>
                    </td>
                    <!-- <td>{{ index + 1 }}</td> -->
                    <td>
                      <button type="button" class="atable gohome">
                        ..
                      </button>
                    </td>
                  </span>
                  <td class="column2"></td>
                  <td class="column3"></td>
                </tr>
                <tr :style="{ height: `${index / 1000 + 10}px` }" v-for="(item, index) in productlistfolder"
                  :key="index" @click="Productchangemodal(item.id);"
                  :class="item.is_folder == true ? 'folderyellow' : ''">
                  <td class="column1">
                    <b-icon v-if="item.is_folder==true" icon="folder-fill"></b-icon>
                  </td>
                  <td>
                    <button type="button" class="atable">
                      {{ item.extra_name }}
                    </button>
                  </td>
                  <td class="column2" style="text-align: end;">
                    <button type="button" class="noborder">
                      {{ item.balance | numFormat}}
                    </button>
                  </td>
                  <td class="column3" style="text-align: end;">
                    <button type="button" class="noborder" v-if="item.price_register">
                      {{ item.price_register.body_price | numFormat }}
                    </button>
                  </td>
                </tr>
              </VueAutoVirtualScrollList>
            </tbody>
          </table>
        </md-card-content>
      </md-card>
    </b-modal>
  </div>
</template>
<script>
  import $ from "jquery";
  import { print } from "../../components/mixins/print.js";
  import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
  export default {
    name: "KirimForm",
    mixins: [print],
    components: { VueAutoVirtualScrollList },
    data() {
      return {
        shtrixlist: [],
        skladlist2: [],
        settedindex: null,
        sklad: "",
        filtermodal: "",
        productlistfolder: [],
        parent: 0,
        filter: "",
        filter1: "",
        focusset: "",
        doklist: [],
        skladlist: [],
        regionlist: [],
        paytypelist: [],
        showDialog: false
      };
    },
    props: ["datas"],
    created: function () {
      let self = this;
      self.$root.$refs.transfer = self;
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      self.$root.$on("paytypeall", function (getdata) {
        self.paytypelist = getdata;
      });
      self.Doklist();
    },
    mounted: function () {
      this.Skladlist2();
      this.SetRule('/transfer/index');
      this.Productlistfolder(this.datas.sklad_id, this.parent);
      (window.onstorage = () => {
        if (localStorage.getItem("setted_product") > 0) {
          this.Productlist();
          this.datas.transfer_table[
            this.$store.state.selected_index
          ].product_id = parseInt(localStorage.getItem("setted_product"));
          this.Productchange(this.$store.state.selected_index);
          localStorage.setItem("setted_product", 0);
          setTimeout(() => {
            this.Next();
          }, 1000);
        }
      }),
        setTimeout(() => {
          localStorage.setItem("sklad_id_dok", this.datas.sklad_id);
          localStorage.setItem("created_at_dok", this.datas.created_at);
        }, 1000);
      this.Focus();
      // this.datas.created_at = this.SetDatetime(this.datas.created_at);
    },
    methods: {
      Sklad2change() {
        let self = this;
        if (self.datas.transfer_sklad_id == self.datas.sklad_id) {
          self.datas.transfer_sklad_id = null;
          self.$store.state.errors = self.$t('Склад2 склад1 бир хил танланди');
        }
      },
      Productchangemodal(id) {
        this.datas.transfer_table[this.$store.state.selected_index].product_id = id;
        this.$bvModal.hide('modal-tovarlistnew');
        this.Productchange(this.$store.state.selected_index);
      },
      Productlistfolder(sklad, parent) {
        let self = this;
        var keyword = "";
        if (self.filtermodal.length > 2) {
          keyword = self.filtermodal;
        }
        axios({
          method: "post",
          url: "api/v1/product/all-price-balance-not-zero/" + parent,
          data: { sklad_id: sklad, datetime: self.datas.created_at, keyword: keyword, parent_id: parent, page: 1, limit: 200 }
        }).then(function (response) {
          self.productlistfolder = response.data;
          // if (response.data.length > 0 && response.data[0].parent_id > 0) {
          //   axios
          //     .get("api/v1/product/id/" + response.data[0].parent_id)
          //     .then(function (response) {
          //       self.parent = response.data.parent_id;
          //     });
          // }
          return false;
        });
      },
      Skladlist2() {
        let self = this;
        axios
          .get("api/v1/sklads/skladnames")
          .then(function (response) {
            self.skladlist2 = response.data;
          });
      },
      CreateProduct(index, search) {
        localStorage.setItem("product_name", search);
        this.$store.state.selected_index = index;
        let routeData = this.$router.resolve({ name: "Товар модал create" });
        window.open(routeData.href, "_blank", "width=1200, height=1000");
      },
      handlerClose: function (event) {
        if (this.$store.state.saved == null) {
          this.$store.state.saved = null;
        } else {
          const answer = window.confirm(
            this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
          );
          if (answer) {
            this.Savedokument();
            event.returnValue = "";
          } else {
            this.$store.state.saved = null;
          }
        }
      },
      SetDok(id) {
        let self = this;
        if (self.sending == false) {
          self.sending = true;
          const str = this.doklist.find(d => d.id === id);
          this.doklist.splice(this.doklist.indexOf(str), 1);
          axios.get("api/v1/prixod/id/" + id).then(function (response) {
            const combined1 = [].concat(
              response.data.prixod_table,
              self.datas.transfer_table
            );
            self.datas.transfer_table = combined1;
            self.Summa();
            self.$bvModal.hide("modal-doklist");
          });
          if (self.sending == true) {
            setTimeout(() => {
              self.sending = false;
            }, 1000);
          }
        }
      },
      Changeoptomprice(index) {
        if (this.datas.transfer_table.length == index + 1) {
          // this.Addtable();
        }
      },
      Changepriceoptomdollar(index) {
        var item = this.datas.transfer_table[index];
        if (item.debit_price > 0) {
          if (this.datas.pay_type_id == 3) {
            item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
            item.optom_percent = parseFloat((item.optom_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            item.optom_summa = item.optom_price * item.count;
          } else {
            item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
            item.optom_percent = parseFloat((item.optom_price / item.debit_price) * 100 - 100).toFixed(2);
            item.optom_summa = item.optom_price * item.count;
          }
        }
      },
      Shoved() {
        let self = this;
        $(document).on("focusout", function (e) {
          if ($(e.target).attr("class") == "vs__search") {
            if (self.focusset == "") {
              self.focusset = e.target;
            }
          }
        });
        self.$refs.inputText2.focus();
      },
      Hide() {
        let self = this;
        setTimeout(function (e) {
          var classs = $(":focus");
          var rrr = $("body")
            .find("input,select,textarea,button")
            .filter(":visible");
          if (classs.attr("class") == "vs__search") {
            if (
              $(self.focusset)
                .siblings(".vs__selected")
                .attr("class") != undefined
            ) {
              var focused = rrr.eq(rrr.index(classs) + 2);
              focused.focus();
            } else {
              $(self.focusset).focus();
            }
          } else if (classs.attr("class") == undefined) {
            if (
              $(self.focusset)
                .siblings(".vs__selected")
                .attr("class") != undefined
            ) {
              focused = rrr.eq(rrr.index($(self.focusset)) + 3);
              focused.focus();
            } else {
              $(self.focusset).focus();
            }
          }
        }, 100);
      },
      Trashitem(index) {
        const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
        if (answer) {
          this.datas.summa -= this.datas.transfer_table[index].debit_summa;
          this.datas.transfer_table.splice(index, 1);
          this.Summa();
        }
      },
      Doklist() {
        let self = this;
        axios
          .get("api/v1/prixod/by-sklad/" + self.datas.sklad_id)
          .then(function (response) {
            self.doklist = response.data;
          });
      },
      Productchange(index) {
        let self = this;
        var item = self.datas.transfer_table[index];
        item.optom_price = 0;
        item.chakana_price = 0;
        self.datas.transfer_table.forEach(function (key, value) {
          if (value != index) {
            if (item.product_id == key.product_id) {
              self.$store.state.errors = self.$t("Бу товар танланган");
              item.product_id = 0;
              item.count = 0;
              item.current_balance = 0;
              item.debit_price = 0;
              item.debit_summa = 0;
              item.chakana_percent = 0;
              item.chakana_dollar_price = 0;
              item.optom_dollar_price = 0;
              item.optom_percent = 0;
              item.chakana_price = 0;
              item.optom_price = 0;
              item.chakana_summa = 0;
              item.optom_summa = 0;
              item.shtrix_kod = "";
              self.Summa();
            }
          }
        });
        if (item.product_id != 0) {
          axios({
            method: "post",
            url: "api/v1/product/price-balance",
            data: {
              product_id: item.product_id,
              sklad_id: self.datas.sklad_id,
              datetime: self.datas.created_at
            }
          }).then(function (response) {
            if (self.datas.pay_type_id == 3) {
              item.current_balance = response.data.balance;
              if (response.data.optom_dollar_price) {
                item.optom_dollar_price = response.data.optom_dollar_price;
                item.optom_price = response.data.optom_price;
              }
              if (response.data.chakana_dollar_price) {
                item.chakana_dollar_price = response.data.chakana_dollar_price;
                item.chakana_price = response.data.chakana_price;
              }
              if (self.sklads.common_price_type == 2) {
                item.debit_price = response.data.body_price;
              } else if (self.sklads.common_price_type == 1) {
                item.debit_price = response.data.body_price / self.datas.dollar_rate;
                window.alert(
                  self.$t("Bu tovar avval boshqa valutada kelgan")
                );
              }
              item.optom_percent = parseFloat((response.data.optom_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
              item.chakana_percent = parseFloat((response.data.chakana_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            } else {
              item.current_balance = response.data.balance;
              if (response.data.optom_dollar_price) {
                item.optom_dollar_price = response.data.optom_dollar_price;
                item.optom_price = response.data.optom_price;
              }
              if (response.data.chakana_dollar_price) {
                item.chakana_dollar_price = response.data.chakana_dollar_price;
                item.chakana_price = response.data.chakana_price;
              }
              if (self.sklads.common_price_type == 1) {
                item.debit_price = response.data.body_price;
              } else if (self.sklads.common_price_type == 2) {
                item.debit_price = response.data.body_price * self.datas.dollar_rate;
                window.alert(
                  self.$t("Bu tovar avval boshqa valutada kelgan")
                );
              }
              item.optom_percent = parseFloat((response.data.optom_price / item.debit_price) * 100 - 100).toFixed(2);
              item.chakana_percent = parseFloat((response.data.chakana_price / item.debit_price) * 100 - 100).toFixed(2);
            }
            item.debit_summa = item.debit_price * item.count;
            self.Setshtrix1(item);
            setTimeout(() => {
              self.Changeprice(index);
            }, 100);
          });
        }
      },
      Focus() {
        if (this.$route.path == "/transfer/create") {
          this.$refs.focused.focus();
        } else {
          $(".table-input")
            .eq(0)
            .focus();
        }
      },
      Qoldiq(item) {
        let self = this;
        axios({
          method: "post",
          url: "api/v1/product/price-balance",
          data: {
            product_id: item.product_id,
            sklad_id: self.datas.sklad_id,
            datetime: self.datas.created_at
          }
        }).then(function (response) {
          item.balance = response.data.balance;
          if (item.count > item.balance) {
            item.current_balance = response.data.balance;
            item.count = item.balance;
            self.$store.state.errors = "Қолдиқ етарли емас";
          }
        });
      },
      Shtrix(index) {
        let self = this;
        var shtrix = self.datas.transfer_table[index].shtrix_kod;
        axios({
          method: "post",
          url: "api/v1/product/shtrix2/" + shtrix,
          data: { sklad_id: self.datas.sklad_id }
        }).then(function (response) {
          if (!response.data[0]) {
          } else if (response.data[1]) {
            self.settedindex = index;
            self.shtrixlist = response.data;
            self.$bvModal.show("modal-shtrix");
          } else {
            self.datas.transfer_table[index].product_id =
              response.data[0].product_id;
            self.Productchange(index);
            var classs = $(":focus");
            var rrr = $("body")
              .find("input,select,textarea,button")
              .filter(":visible");
            var focused = rrr.eq(rrr.index(classs) + 2);
            focused.focus();
          }
        });
      },
      Selectproduct(index) {
        this.$store.state.selected_index = index;
        this.$bvModal.show('modal-tovarlistnew');
        // let routeData = this.$router.resolve({ name: "Товар модал" });
        // window.open(routeData.href, "_blank", "width=1200, height=1000");
      },
      Changeprice(index) {
        var item = this.datas.transfer_table[index];
        let self = this;
        if (self.datas.pay_type_id == 3) {
          if (item.chakana_dollar_price > 0) {
            self.Changepricechakanadollar(index);
          }
          if (item.optom_dollar_price > 0) {
            self.Changepriceoptomdollar(index);
          }
        } else {
          if (item.optom_price > 0) {
            this.Changepriceoptom(index);
          }
          if (item.chakana_price > 0) {
            this.Changepricechakana(index);
          }
        }
        item.debit_summa = item.debit_price * item.count;
        this.Summa();
      },
      Changepricechakanadollar(index) {
        var item = this.datas.transfer_table[index];
        if (item.debit_price > 0) {
          if (this.datas.pay_type_id == 3) {
            item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
            item.chakana_percent = parseFloat((item.chakana_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            item.chakana_summa = item.chakana_price * item.count;
          } else {
            item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
            item.chakana_percent = parseFloat((item.chakana_price / item.debit_price) * 100 - 100).toFixed(2);
            item.chakana_summa = item.chakana_price * item.count;
          }
        }
      },
      Changepriceoptomdollar(index) {
        var item = this.datas.transfer_table[index];
        if (item.debit_price > 0) {
          if (this.datas.pay_type_id == 3) {
            item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
            item.optom_percent = parseFloat((item.optom_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            item.optom_summa = item.optom_price * item.count;
          } else {
            item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
            item.optom_percent = parseFloat((item.optom_price / item.debit_price) * 100 - 100).toFixed(2);
            item.optom_summa = item.optom_price * item.count;
          }
        }
      },
      Changecount(index) {
        let self = this;
        var item = this.datas.transfer_table[index];
        if (item.balance) {
          if (item.count > item.balance) {
            item.count = item.balance;
            self.$store.state.errors = "Қолдиқ етарли емас";
          }
        } else {
          axios({
            method: "post",
            url: "api/v1/product/price-balance",
            data: {
              product_id: item.product_id,
              sklad_id: self.datas.sklad_id,
              datetime: self.datas.created_at
            }
          }).then(function (response) {
            item.balance = response.data.balance;
            if (item.count > item.balance) {
              item.current_balance = response.data.balance;
              item.count = item.balance;
              self.$store.state.errors = "Қолдиқ етарли емас";
            }
          });
        }
        if (item.debit_price > 0) {
          item.debit_summa = item.count * item.debit_price;
        }
        if (item.optom_price > 0) {
          item.optom_summa = item.count * item.optom_price;
        }
        if (item.chakana_price > 0) {
          item.chakana_summa = item.count * item.chakana_price;
        }
        this.Summa();
      },
      Changepercentoptom(index) {
        var item = this.datas.transfer_table[index];
        // item.optom_price = item.debit_price * (item.optom_percent / 100 + 1);
        // item.optom_summa = item.optom_price * item.count;
        if (this.datas.pay_type_id == 3) {
          item.optom_dollar_price = item.debit_price * (item.optom_percent / 100 + 1);
          item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
          item.optom_summa = item.optom_price * item.count;
        } else {
          item.optom_price = item.debit_price * (item.optom_percent / 100 + 1);
          item.optom_summa = item.optom_price * item.count;
          item.optom_dollar_price = item.optom_price / this.datas.dollar_rate;
        }
      },
      Changepercentchakana(index) {
        var item = this.datas.transfer_table[index];
        // item.chakana_price =
        //   parseInt(item.debit_price) * (item.chakana_percent / 100 + 1);
        // item.chakana_summa = item.chakana_price * item.count;
        if (this.datas.pay_type_id == 3) {
          item.chakana_dollar_price = item.debit_price * (item.chakana_percent / 100 + 1);
          item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
          item.chakana_summa = item.chakana_price * item.count;
        } else {
          item.chakana_price = item.debit_price * (item.chakana_percent / 100 + 1);
          item.chakana_summa = item.chakana_price * item.count;
          item.chakana_dollar_price = item.chakana_price / this.datas.dollar_rate;
        }
      },
      Changepriceoptom(index) {
        var item = this.datas.transfer_table[index];
        if (item.debit_price > 0) {
          if (this.datas.pay_type_id == 3) {
            item.optom_dollar_price = item.optom_price / this.datas.dollar_rate;
            item.optom_percent = parseFloat((item.optom_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            item.optom_summa = item.optom_price * item.count;
          } else {
            item.optom_percent = parseFloat((item.optom_price / item.debit_price) * 100 - 100).toFixed(2);
            item.optom_summa = item.optom_price * item.count;
            item.optom_dollar_price = item.optom_price / this.datas.dollar_rate;
          }
        }
      },
      Changepricechakana(index) {
        var item = this.datas.transfer_table[index];
        if (this.datas.pay_type_id == 3) {
          item.chakana_dollar_price = item.chakana_price / this.datas.dollar_rate;
          item.chakana_percent = parseFloat((item.chakana_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
          item.chakana_summa = item.chakana_price * item.count;
        } else {
          item.chakana_percent = parseFloat((item.chakana_price / item.debit_price) * 100 - 100).toFixed(2);
          item.chakana_summa = item.chakana_price * item.count;
          item.chakana_dollar_price = item.chakana_price / this.datas.dollar_rate;
        }
      },
      Changepricechakanadollar(index) {
        var item = this.datas.transfer_table[index];
        if (item.debit_price > 0) {
          if (this.datas.pay_type_id == 3) {
            item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
            item.chakana_percent = parseFloat((item.chakana_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            item.chakana_summa = item.chakana_price * item.count;
          } else {
            item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
            item.chakana_percent = parseFloat((item.chakana_price / item.debit_price) * 100 - 100).toFixed(2);
            item.chakana_summa = item.chakana_price * item.count;
          }
        }
      },
      Addtable() {
        this.datas.transfer_table.push({
          product_id: 0,
          current_balance: 0,
          count: 0,
          debit_price: 0,
          debit_summa: 0,
          chakana_percent: 0,
          chakana_dollar_price: 0,
          optom_dollar_price: 0,
          optom_percent: 0,
          chakana_price: 0,
          optom_price: 0,
          chakana_summa: 0,
          optom_summa: 0,
          shtrix_kod: ""
        });
        this.Tablefocus();
      },
      Summa() {
        this.datas.summa = 0;
        this.datas.count_all = 0;
        let self = this;
        this.datas.transfer_table.forEach(function (key, value) {
          self.Qoldiq(key);
          self.datas.summa += parseFloat(key.debit_summa);
          self.datas.count_all += parseFloat(key.count);
        });
      },
      Savedokument(type) {
        var type;
        let self = this;
        // if (self.rule.open == true) {
        if (self.sending == false) {
          self.sending = true;
          if (this.$route.path == "/transfer/create") {
            var methods = "post";
            var action = "api/v1/transfer";
          } else {
            if (self.$store.state.saved == 1) {
              self.datas.updated_at = new Date()
                .valueOf()
                .toString()
                .slice(0, 10);
            }
            var methods = "patch";
            var action = "api/v1/transfer/id/" + self.$route.params.id;
          }
          // self.datas.created_at = new Date(self.datas.created_at)
          //   .valueOf()
          //   .toString()
          //   .slice(0, 10);
          axios({
            method: methods,
            url: action,
            data: self.datas
          }).then(function (response) {
            self.$store.state.saved = null;
            if (type == "print") {
              let myWindow;
              myWindow = window.open(
                '#/transfer/print/' + response.data.id,
                "_blank",
                "width=1000, height=1000"
              );
              self.$router.push({ name: "Перемешения" });
            } else if (type == 'barcode') {
              let myWindow;
              myWindow = window.open(
                '#/transfer/barcode/' + response.data.id,
                "_blank",
                "width=500, height=800"
              );
            } else {
              self.$router.push({ name: "Перемешения" });
            }
          });
          if (self.sending == true) {
            setTimeout(() => {
              self.sending = false;
            }, 1000);
          }
        }
        // } else {
        //   self.$store.state.errors = self.$t('Sizdan bunday xuquq mavjud emas');
        // }
      }
    },
    computed: {
      confirmed() {
        if (this.datas.confirm == true) {
          return true;
        } else {
          if (this.datas.sklad_id == this.skladid) {
            if (this.changedisabled == false) {
              return false;
            } else {
              return true;
            }
          } else { return true; }
        }
      },
      changedisabledconfirm() {
        if (this.datas.confirm == true) {
          return true;
        } else if (this.changedisabled == false) {
          return false;
        } else { return true; }
      },
      skladid() {
        return parseInt(localStorage.getItem('sklad_id'));
      },
      SelectedProduct() {
        return this.$store.state.selected_product;
      },
      filtereddok() {
        return this.doklist.filter(row => {
          const name = new Date(row.created_at * 1000)
            .toISOString()
            .substr(0, 19);
          const searchTerm = this.filter1.toLowerCase();
          return name.includes(searchTerm);
        });
      },
      filteredRows() {
        return this.shtrixlist.filter(row => {
          const name = row.name.toString().toLowerCase();
          const searchTerm = this.filter.toLowerCase();
          return name.includes(searchTerm);
        });
      }
    },
    watch: {
      "$store.state.changed": function () {
        if (this.$store.state.changed != null) {
          this.Productchange(this.$store.state.selected_index);
          this.$store.state.changed = null;
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .md-card-content>.table.table-bordered tbody {
    display: block;
    height: 70vh;
    overflow-y: scroll;
  }

  .md-card-content>.table.table-bordered thead,
  .md-card-content>.table.table-bordered tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
</style>